const questions = [
  // 1 Слайд \\ мотошлем [1]
  {
    questionDesc: [
      "Helm motor adalah perlengkapan yang diperlukan oleh para pengemudi. Helm Maxim punya gaya tersendiri dan kuat: diproduksi dari plastik tebal, dengan pelindung yang kuat, dan lapisan dalam yang empuk.",
    ],
    questionText:
      "Bagaimana menurut kamu, berapa lama sih, helm sudah ada di dunia?",
    answerOptions: [
      {
        answerText: "30",
        answerResult:
          "Helm pertama diciptakan pada tahun 1914. Prototipenya dibuat dari kulit dan gabus.",
        result: false,
      },
      {
        answerText: "50",
        answerResult:
          "Helm pertama diciptakan pada tahun 1914. Prototipenya dibuat dari kulit dan gabus.",
        result: false,
      },
      {
        answerText: "70",
        answerResult:
          "Helm pertama diciptakan pada tahun 1914. Prototipenya dibuat dari kulit dan gabus.",
        result: false,
      },
      {
        answerText: "100",
        answerResult:
          "Helm pertama diciptakan pada tahun 1914. Prototipenya dibuat dari kulit dan gabus.",
        result: true,
      },
    ],
    image: "images/1.webp",
  },

  // 2 слайд \\ Ни разу [4]
  {
    questionDesc: [
      "Mulai tahun 2000-an, institut warna Pantone setiap tahunnya memilih satu warna paling tren. Warna hitam kaus kita merupakan simbol keeleganan dan kepraktisan.",
    ],
    questionText:
      "Tetapi, berapa kali warna ini menjadi warna tahun itu menurut Pantone?",
    answerOptions: [
      {
        answerText: "Tidak pernah sekali pun",
        answerResult:
          "Warna hitam disukai oleh jutaan orang dari seluruh dunia, tetapi institut warna Pantone tidak pernah menyematkan anugerah “warna tahun ini” kepada warna tersebut.",
        result: true,
      },
      {
        answerText: "1 kali",
        answerResult:
          "Warna hitam disukai oleh jutaan orang dari seluruh dunia, tetapi institut warna Pantone tidak pernah menyematkan anugerah “warna tahun ini” kepada warna tersebut.",
        result: false,
      },
      {
        answerText: "2 kali",
        answerResult:
          "Warna hitam disukai oleh jutaan orang dari seluruh dunia, tetapi institut warna Pantone tidak pernah menyematkan anugerah “warna tahun ini” kepada warna tersebut.",
        result: false,
      },
      {
        answerText: "4 kali",
        answerResult:
          "Warna hitam disukai oleh jutaan orang dari seluruh dunia, tetapi institut warna Pantone tidak pernah menyematkan anugerah “warna tahun ini” kepada warna tersebut.",
        result: false,
      },
    ],
    image: "images/2.webp",
  },

  // 3 слайд \\ Французские циркачи [1]
  {
    questionDesc: [
      "Rompi adalah barang universal yang ada di lemari, cocok untuk cuaca panas maupun dingin. Di rompi berlogo perusahaan Maxim ada garis reflektif supaya nyaman dikenakan pada saat hari mulai gelap!",
    ],
    questionText:
      "Menurut salah satu versi, rompi pertama digunakan di pasar kaget. Siapakah kira-kira yang mengenakannya?",
    answerOptions: [
      {
        answerText: "Para pedagang Turki",
        answerResult:
          "Menurut salah satu versi, mereka adalah para pemain sirkus Prancis. Mereka menyebut rompi sebagai gilie, yang dinamai berdasarkan karakter lawak yang tampil mengenakan rompi.",
        result: false,
      },
      {
        answerText: "Para pemain sirkus Prancis",
        answerResult:
          "Menurut salah satu versi, mereka adalah para pemain sirkus Prancis. Mereka menyebut rompi sebagai gilie, yang dinamai berdasarkan karakter lawak yang tampil mengenakan rompi.",
        result: true,
      },
      {
        answerText: "Para aktor lawak Italia",
        answerResult:
          "Menurut salah satu versi, mereka adalah para pemain sirkus Prancis. Mereka menyebut rompi sebagai gilie, yang dinamai berdasarkan karakter lawak yang tampil mengenakan rompi.",
        result: false,
      },
      {
        answerText: "Para petarung banteng Spanyol",
        answerResult:
          "Menurut salah satu versi, mereka adalah para pemain sirkus Prancis. Mereka menyebut rompi sebagai gilie, yang dinamai berdasarkan karakter lawak yang tampil mengenakan rompi.",
        result: false,
      },
    ],
    image: "images/3.webp",
  },

  // 4 слайд \\ От языка хинди – «bāṅdhnū» - повязывать  [3]
  {
    questionDesc: [
      "Bandana adalah teman setia para pengemudi motor dan aksesori modis untuk teman-temannya.",
    ],
    questionText: "Kita jarang berpikir mengapa kain ini disebut demikian?",
    answerOptions: [
      {
        answerText: "Dari kata Band",
        answerResult:
          "Terlepas dari asal kata “bandana” yang berasal dari bahasa Hindi, popularitas kain ini diperoleh berkat para koboi Amerika. Dan juga oleh para pengemudi kami, tentunya.",
        result: false,
      },
      {
        answerText: "Dari bahasa Inggris “to bound” yang artinya mengikat",
        answerResult:
          "Terlepas dari asal kata “bandana” yang berasal dari bahasa Hindi, popularitas kain ini diperoleh berkat para koboi Amerika. Dan juga oleh para pengemudi kami, tentunya.",
        result: false,
      },
      {
        answerText: "Dari bahasa Hindi–“bāṅdhnū” yang artinya mengikat",
        answerResult:
          "Terlepas dari asal kata “bandana” yang berasal dari bahasa Hindi, popularitas kain ini diperoleh berkat para koboi Amerika. Dan juga oleh para pengemudi kami, tentunya.",
        result: true,
      },
      {
        answerText: "Dari kata “banana” karena dihiasi gambar pisang",
        answerResult:
          "Terlepas dari asal kata “bandana” yang berasal dari bahasa Hindi, popularitas kain ini diperoleh berkat para koboi Amerika. Dan juga oleh para pengemudi kami, tentunya.",
        result: false,
      },
    ],
    image: "images/4.webp",
  },

  // 5 слайд \\ Прозрачный винил [2]
  {
    questionDesc: [
      "Tas pinggang populer di kalangan pengemudi Maxim, kurir, penjual. Barang-barang selalu bisa dibawa serta dan tangan masih tetap bebas!",
    ],
    questionText: "Dari bahan apakah tas pinggang pada tahun 1990-an dibuat?",
    answerOptions: [
      {
        answerText: "Karet",
        answerResult:
          "Pada akhir tahun 90-an, tas pinggang dari bahan vinyl transparan menjadi tren. Ini adalah bagian dari estetika zaman itu.",
        result: false,
      },
      {
        answerText: "Plastik",
        answerResult:
          "Pada akhir tahun 90-an, tas pinggang dari bahan vinyl transparan menjadi tren. Ini adalah bagian dari estetika zaman itu.",
        result: false,
      },
      {
        answerText: "Jaring logam",
        answerResult:
          "Pada akhir tahun 90-an, tas pinggang dari bahan vinyl transparan menjadi tren. Ini adalah bagian dari estetika zaman itu.",
        result: false,
      },
      {
        answerText: "Bahan vinyl transparan",
        answerResult:
          "Pada akhir tahun 90-an, tas pinggang dari bahan vinyl transparan menjadi tren. Ini adalah bagian dari estetika zaman itu.",
        result: true,
      },
    ],
    image: "images/5.webp",
  },
  // 6 слайд \\ Потому что желтый — фирменный цвет сервиса заказа такси Максим. [2]
  {
    questionDesc: [
      "Tokoh-tokoh yang mengenakan jas hujan kuning sudah lama menjadi bagian dari budaya pop. Kita bisa melihatnya di poster film “IT”. Jas hujan ini digunakan juga oleh Coraline dan Winnie Pooh. Jadi, kami pun membuat jas hujan anti air kami dengan warna kuning cerah.",
    ],
    questionText: "Mengapa?",
    answerOptions: [
      {
        answerText:
          "Karena kuning adalah warna tradisional taksi di seluruh dunia.",
        answerResult:
          "Jas hujan bisa berwarna apa saja dan ini tidak akan memengaruhi karakteristiknya. Oleh sebab itu, kami memilih kuning seperti warna perusahaan kami.",
        result: false,
      },
      {
        answerText: "Karena kain berwarna kuning memiliki sifat anti air.",
        answerResult:
          "Jas hujan bisa berwarna apa saja dan ini tidak akan memengaruhi karakteristiknya. Oleh sebab itu, kami memilih kuning seperti warna perusahaan kami.",
        result: false,
      },
      {
        answerText: "Karena kuning adalah warna perusahaan layanan Maxim.",
        answerResult:
          "Jas hujan bisa berwarna apa saja dan ini tidak akan memengaruhi karakteristiknya. Oleh sebab itu, kami memilih kuning seperti warna perusahaan kami.",
        result: true,
      },
      {
        answerText: "Warna ini memenangkan suara di pemilihan di komunitas.",
        answerResult:
          "Jas hujan bisa berwarna apa saja dan ini tidak akan memengaruhi karakteristiknya. Oleh sebab itu, kami memilih kuning seperti warna perusahaan kami.",
        result: false,
      },
    ],
    image: "images/6.webp",
  },
];

export default questions;
